import { Button } from "@material-ui/core";
import buttonStyle from "../../commom/styles/buttonStyle";

/**
 * @author IKlapouch
 * @date 12/07/2023
 * @description ET:44 - Button layout improvements
 **/

export const BaseButton = (props) => {
    const classes = buttonStyle();
    return (
        <Button
            size='large'
            fullWidth
            style={{ textTransform: 'none', fontWeight: 'normal' }}
            disabled={props.disabled}
            onClick={props.onClick}
            className={props.disabled ? classes.disabledButton : classes.button}
            startIcon={props.startIcon}
            {...props}
        >
            {props.label}
        </Button>
    );
};
